<div class="container-fluid mt-3">
  <h1>Document History</h1>
  <button type="button" class="btn btn-primary mb-3" *ngIf="canEmailClients" [disabled]="isEmailSending" (click)="emailClients()">Email client history links</button>
  <div class="alert alert-info" *ngIf="emailMessage">{{ emailMessage }}</div>

  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="alert alert-info" *ngIf="history && history.length === 0">No signature history was found for this document.</div>

  <table class="table table-striped" *ngIf="history && history.length > 0">
    <thead>
      <tr>
        <th>Date</th>
        <th>Action</th>
        <th>Name</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let entry of history">
        <td>{{ entry.date | date:'shortDate' }} {{ entry.date | date:'shortTime' }}</td>
        <td>{{ entry.action }}</td>
        <td>{{ entry.name }}</td>
      </tr>
    </tbody>
  </table>
</div>
